import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAreasState, areasAdapter, areasKey } from './areas.state';
import { AreaModel } from '@app/api/enums/area-model.enum';

export const selectAreasState = createFeatureSelector<IAreasState>(areasKey);

const { selectAll, selectEntities, selectIds, selectTotal } = areasAdapter.getSelectors(selectAreasState);

export const selectAllAreas = selectAll;
export const selectAreaEntities = selectEntities;
export const selectAreaIds = selectIds;
export const selectAreasTotal = selectTotal;

export const selectAreasLoading = createSelector(selectAreasState, state => state.loading);
export const selectAreasLoaded = createSelector(selectAreasState, state => state.loaded);
export const selectAreasError = createSelector(selectAreasState, state => state.error);

export const selectAreasById = (areaId: string) => createSelector(selectAreaEntities, areasMap => areasMap[areaId]);

export const selectAreasByProjectId = (projectId: string) =>
  createSelector(selectAllAreas, areas => areas.filter(area => area.projectId === projectId));

export const selectLoadedModelByProjectId = createSelector(
  selectAreasState,
  (state: IAreasState) => state.loadedByProjectId
);

export const isProjectAreasLoaded = (projectId: string, requiredModel: AreaModel) =>
  createSelector(selectLoadedModelByProjectId, loadedMap => {
    const current = loadedMap[projectId];
    if (requiredModel === AreaModel.IncludeBoundaryNodes) {
      return current === AreaModel.IncludeBoundaryNodes;
    } else {
      return current !== undefined;
    }
  });
